module.exports = __webpack_public_path__ + "img/fish-1.6ee717d3.jpg";